module.exports = __webpack_public_path__ + "static/media/JiggyMainTransparent.697bc628.png";